export default {
  slug: "resharper",
  code: "RS",
  label: "ReSharper",
  isIDE: true,
  krakenDir: "ReSharper",
  thumbnailColor: "#FDB60D",
  logoFamily: "ide",
};
